import React from 'react'
import logApolloError from 'lib/logApolloError'

import Seo from 'components/CmsPage/Seo'
import usePage from 'hooks/usePage'

const SearchSeo = (): JSX.Element => {
  const { page, error, loading } = usePage('search')

  if (error) {
    logApolloError(
      `[ContentLoad Error] Error loading content for page: search`,
      error,
    )
  }

  if (loading) return null

  const pageMetadata = page?.cmsItemPageMetadata

  return <Seo pageMetadata={pageMetadata} />
}

export default SearchSeo
